import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    text: 'Ich war skeptisch, aber nach 2 Wochen hatte Bruno zum ersten Mal wieder normalen Stuhl. Wir sind so erleichtert.',
    author: 'Sandra',
    dogInfo: 'Hund: Balu, Labrador, 4 Jahre',
    dogImage: 'https://images.unsplash.com/photo-1579296513824-fc7895cadd04?w=100&h=100&fit=crop&crop=faces'
  }, {
    text: 'Charlie hatte wochenlang starke Blähungen und laute Darmgeräusche. Nach dem Topping hat sich das innerhalb von 14 Tagen komplett gelegt.',
    author: 'Michael',
    dogInfo: 'Hund: Charlie, Golden Retriever, 6 Jahre',
    dogImage: 'https://images.unsplash.com/photo-1633722715463-d30f4f325e24?w=100&h=100&fit=crop&crop=faces'
  }, {
    text: 'Seit wir das Magen-Darm-Topping regelmäßig geben, geht es unserer Luna viel viel besser. Macht weiter so!',
    author: 'Familie Weber',
    dogInfo: 'Hund: Luna, Mischling, 3 Jahre',
    dogImage: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=100&h=100&fit=crop&crop=faces'
  }, {
    text: 'Nach zwei Wochen hatte unser Hund keine Beschwerden mehr. So einfach.',
    author: 'Thomas',
    dogInfo: 'Hund: Max, Dackel, 8 Jahre',
    dogImage: 'https://images.unsplash.com/photo-1612195583950-b8fd34c87093?w=100&h=100&fit=crop&crop=faces'
  }];
  return <section className="w-full px-4 py-16 bg-cream-dark/50" data-id="element-164">
      <div className="max-w-6xl mx-auto" data-id="element-165">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="font-handwriting text-4xl md:text-5xl text-center text-forest font-bold mb-12" data-id="element-166">
          Was andere Hundebesitzer sagen
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-167">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-brown/10" data-id="element-168">
              <div className="flex items-start gap-4 mb-4" data-id="element-169">
                <img src={review.dogImage} alt={`Hund von ${review.author}`} className="w-12 h-12 rounded-full object-cover shrink-0 border border-brown/20" data-id="element-170" />
                <div className="flex-1" data-id="element-171">
                  <p className="font-serif font-bold text-gray-900" data-id="element-172">
                    {review.author}
                  </p>
                  <p className="font-serif text-sm text-gray-500" data-id="element-173">
                    ({review.dogInfo})
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-3" data-id="element-174">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-175" />)}
              </div>

              <p className="font-serif text-gray-700 leading-relaxed" data-id="element-176">
                {review.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}